import styled from '@emotion/styled';

export const NavigationContainer = styled.nav`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    height: 70px;
    background: white;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    font-family: 'SCDream4', sans-serif;
    z-index: 1000;

    ${(props) =>
        props.variant === 'vertical' &&
        `
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        height: 100vh;
        width: 280px;
        padding: 24px 0;
        box-shadow: 2px 0 20px rgba(0, 0, 0, 0.1);
    `}

    @media (max-width: 768px) {
        padding: 0 16px;
        height: 60px;
    }
`;

export const LogoSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;

export const LogoImage = styled.img`
    width: 40px;
    height: 40px;
    object-fit: contain;
`;

export const LogoText = styled.h1`
    font-size: 24px;
    font-weight: 700;
    color: #333333;
    margin: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 768px) {
        font-size: 20px;
    }
`;

export const DesktopMenu = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    ${(props) =>
        props.variant === 'vertical' &&
        `
        flex-direction: column;
        align-items: stretch;
        width: 100%;
        gap: 0;
        margin-top: 32px;
    `}
`;

export const NavItem = styled.div`
    position: relative;
    display: flex;
    align-items: center;

    ${(props) =>
        props.variant === 'vertical' &&
        `
        width: 100%;
    `}
`;

export const NavLink = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: none;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #666666;
    text-decoration: none;
    transition: all 0.3s ease;
    white-space: nowrap;
    outline: none;

    &:hover {
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
        color: #667eea;
        transform: translateY(-1px);
    }

    &:focus {
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    ${(props) =>
        props.isActive &&
        `
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        
        &:hover {
            background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
            transform: translateY(-1px);
        }
    `}

    ${(props) =>
        props.hasSubmenu &&
        `
        padding-right: 12px;
    `}
`;

export const ItemIcon = styled.div`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    svg {
        width: 18px;
        height: 18px;
    }
`;

export const ItemText = styled.span`
    font-weight: 500;
`;

export const SubmenuIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: inherit;
    transition: transform 0.3s ease;
    transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const Submenu = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 200px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    border: 1px solid #e0e0e0;
    padding: 8px 0;
    z-index: 1001;
    animation: slideDown 0.3s ease-out;

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px) scale(0.95);
        }
        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    ${(props) =>
        props.variant === 'vertical' &&
        `
        position: static;
        box-shadow: none;
        border: none;
        padding: 0;
        margin-top: 8px;
        margin-left: 16px;
        border-left: 2px solid #e0e0e0;
        animation: slideRight 0.3s ease-out;

        @keyframes slideRight {
            from {
                opacity: 0;
                transform: translateX(-10px);
            }
            to {
                opacity: 1;
                transform: translateX(0);
            }
        }
    `}
`;

export const SubmenuItem = styled.div`
    width: 100%;
`;

export const SubmenuLink = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 10px 16px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 13px;
    color: #666666;
    text-decoration: none;
    transition: all 0.2s ease;
    outline: none;

    &:hover {
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
        color: #667eea;
        transform: translateX(4px);
    }

    &:focus {
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    }

    ${(props) =>
        props.isActive &&
        `
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
        color: #667eea;
        border-left: 3px solid #667eea;
        padding-left: 13px;
    `}
`;

export const SubmenuText = styled.span`
    font-weight: 500;
`;

// 모바일 메뉴 스타일
export const MobileMenuButton = styled.button`
    display: none;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: none;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    color: #666666;
    transition: all 0.3s ease;
    outline: none;

    &:hover {
        background: rgba(102, 126, 234, 0.1);
        color: #667eea;
    }

    &:focus {
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    svg {
        width: 24px;
        height: 24px;
        transition: transform 0.3s ease;
        transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    }

    @media (max-width: 768px) {
        display: flex;
    }
`;

export const MobileOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
    animation: fadeIn 0.3s ease-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

export const MobileMenu = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 300px;
    height: 100vh;
    background: white;
    box-shadow: -2px 0 20px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    transform: ${(props) => (props.isOpen ? 'translateX(0)' : 'translateX(100%)')};
    transition: transform 0.3s ease-out;
    display: flex;
    flex-direction: column;
`;

export const MobileMenuHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid #e0e0e0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
`;

export const MobileLogo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 6px;
    cursor: pointer;
    color: white;
    transition: all 0.2s ease;
    outline: none;

    &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(1.05);
    }

    svg {
        width: 20px;
        height: 20px;
    }
`;

export const MobileMenuContent = styled.div`
    flex: 1;
    padding: 24px 0;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
`;
